export interface FeedTitleProps {
  title?: string;
  creator?: string | null;
  description?: string;
}

export function FeedTitle({ title, creator, description }: FeedTitleProps) {
  return (
    <div className="lookbook--feed--title">
      {title?.length ? (
        <h1 className="lookbook--feed--title--title">{title}</h1>
      ) : null}
      {creator?.length ? (
        <h2
          className="lookbook--feed--title--creator"
          data-test-id="lookbook-creator">
          by {creator}
        </h2>
      ) : null}
      {description?.length ? (
        <p className="lookbook--feed--title--description">{description}</p>
      ) : null}
    </div>
  );
}
